export default __webpack_public_path__ + "static/media/Slider1.9804bcbc.jpg";